import React from 'react'
import { CardInfo } from '../../../../../../Portfolio_R/SummaryCharts/components/CardInfo'

const CompositionProjectsCard = ({ t, mp }) => {
    return (
        <div className="composition content-composition">
            <div>
                <h3 className="chart-title">{t('one_pager_report.composition')}</h3>
                <div className="chart-content">
                    <CardInfo title={t('one_pager_report.total_projects')} data={mp.fields.projectTotalCount} />
                    <CardInfo title={t('one_pager_report.national_projects')} data={mp.fields.projectTotalCountNational} />
                    <CardInfo title={t('one_pager_report.regional_projects')} data={mp.fields.projectTotalCountRegional} />
                </div>
            </div>
            <div className="chart-row mt-4">
                <div className="grid-chart-content">
                    <CardInfo title={t('one_pager_report.operations')} data={mp.fields.operationTotalCount} />
                    <CardInfo
                        title={t('one_pager_report.years')}
                        data={mp.fields.averageAge}
                        units={
                            (mp.fields.averageAge) > 1
                                ? t('one_pager_report.antiquity_years')
                                : t('one_pager_report.antiquity_year')
                        }
                    />
                </div>
            </div>
        </div>
    )
}

export default CompositionProjectsCard